import { render, staticRenderFns } from "./tmp-radish.vue?vue&type=template&id=143e6457"
import script from "./tmp-radish.vue?vue&type=script&lang=js"
export * from "./tmp-radish.vue?vue&type=script&lang=js"
import style0 from "./tmp-radish.vue?vue&type=style&index=0&id=143e6457&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports